import { THEME } from '@common/constants/theme.constant';
import { Field, IFieldProps } from '@common/general-ui/field/field.component';
import { Readonly } from '@common/general-ui/readonly.component';
import { SerializedStyles } from '@emotion/react';
import { Switch as AntdSwitch } from 'antd';
import { SwitchChangeEventHandler } from 'antd/lib/switch';
import React, { useCallback, useEffect, useState } from 'react';
import { css } from 'twin.macro';

export interface ISwitchProps<TName = string> extends IFieldProps<boolean, TName> {
    className?: string;
    readOnly?: boolean;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
    variant?: 'block' | 'inline';
}

export const Switch = (props: ISwitchProps): JSX.Element => {
    const { size: _size, onChange, errorMessage, helperText, variant = 'inline', ...rest } = props;
    const [checked, setChecked] = useState(props.value);

    const handleChange = useCallback<SwitchChangeEventHandler>(
        (val, e) => {
            setChecked(val);

            onChange &&
                onChange({
                    ...e,
                    target: {
                        ...e.target,
                        checked: val,
                        value: val,
                    },
                } as unknown as React.ChangeEvent<HTMLInputElement>);
        },
        [onChange],
    );

    useEffect(() => {
        setChecked(props.value);
    }, [props.value]);
    return (
        <Field {...props} tw="relative">
            {props.label && <>&nbsp;</>}
            {variant === 'block' && <div tw="pt-1" />}
            <div tw="relative inline">
                {props.readOnly && <Readonly />}
                <AntdSwitch
                    {...rest}
                    checked={checked}
                    onChange={handleChange}
                    className={props.className}
                    css={styles.switch(!!props.readOnly)}
                />
            </div>
        </Field>
    );
};

const styles = {
    switch: (readOnly: boolean): (SerializedStyles | boolean)[] => [
        readOnly &&
            css`
                &&.ant-switch-checked {
                    background-color: ${THEME.READONLY_COLOR};
                }
            `,
    ],
};
